import {
  SUBMIT_TITLE,
  SUBMIT_TITLE_SUCCESS,
  SUBMIT_TITLE_FAILED,
  SET_OPEN_SALVAGE_ALERT,
  SET_MOVE_TO_NEXT_TAB,
} from './types';

export const submitTitle = (data) => ({
  type: SUBMIT_TITLE,
  payload: data,
});

export const submitTitleSuccess = (data) => ({
  type: SUBMIT_TITLE_SUCCESS,
  payload: data,
});

export const submitTitleFailed = (error) => ({
  type: SUBMIT_TITLE_FAILED,
  payload: error,
});

export const setOpenSalvageAlert = (open) => ({
  type: SET_OPEN_SALVAGE_ALERT,
  payload: open
})

export const setMoveToNextTab = (open) => ({
  type: SET_MOVE_TO_NEXT_TAB,
  payload: open
})
